import { render, staticRenderFns } from "./sensitiveWord.vue?vue&type=template&id=90bce934&scoped=true&"
import script from "./sensitiveWord.vue?vue&type=script&lang=js&"
export * from "./sensitiveWord.vue?vue&type=script&lang=js&"
import style0 from "./sensitiveWord.vue?vue&type=style&index=0&id=90bce934&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bce934",
  null
  
)

export default component.exports